import React, { useEffect, useLayoutEffect, useState } from 'react';
import './App.css';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { ThemeProvider } from '@mui/material/styles';
import { UntappdMenuItem, UntappdMenuContainer } from './untappd-types';
import MobileDisplayItemV3 from './MobileDisplayItemV3';
import Typography from '@mui/material/Typography';
import { Routes, Route, useParams } from 'react-router-dom';
import MobileWineItem from './MobileWineItem';
import { WineMenuItem } from './menu-types';

//Read for more about CSS Grid layouts: https://mui.com/system/grid/

const whiteRose1: WineMenuItem = { id: 1, name: 'Vinho Verde', style: 'Signature', price: 7, description: 'Portugal DOC - Spritzy / Green Apple / White Peach' }
const whiteRose2: WineMenuItem = { id: 2, name: 'Rosé', style: 'Signature', price: 13, description: 'Cote de Rhone, Rance - Crisp / Red Currant / Strawberry' }
const whiteRose3: WineMenuItem = { id: 3, name: 'Chardonnay', style: 'Signature', price: 11, description: 'California - Tropical Fruit / Full / Un-Oaked' }
const whiteRose4: WineMenuItem = { id: 4, name: 'Sauv Blanc', style: 'Signature', price: 16, description: 'Cotes de Gascogne, France - Citrus Fruit / Blackcurrent Leaf' }
const whiteRose5: WineMenuItem = { id: 5, name: 'Moscato', style: 'Signature', price: 7, description: 'Italy DOCG - Sweet / Tangerine / Honey' }
const whiteRose6: WineMenuItem = { id: 6, name: 'Sparkling Brut', style: 'Signature', price: 8, description: 'Italy DOCG - Dry / Tart / Lemon Peel' }

const red1: WineMenuItem = { id: 11, name: 'Chianti', style: 'Signature', price: 7.5, description: 'Italy DOCG - Cherry / Flroal / Soft Tannins' }
const red2: WineMenuItem = { id: 12, name: 'Cabernet', style: 'Signature', price: 8.5, description: 'Sauvingon California - Ripe Berries / Warm Spices / Oak' }
const red3: WineMenuItem = { id: 13, name: 'GSM21', style: 'Signature', price: 7.5, description: 'South of France - Red Cherry / Raspberry / Silky' }




const MobileWineMenu = () => {
  return (
    <main style={{ backgroundColor: 'black', overflowY: 'hidden', paddingTop: '0.5em', paddingLeft: '0em' }}>
      {/* Hero unit */}
        <Container sx={{ py: 0.0, px: 0.25, paddingTop: '0px' }} maxWidth={false}>
          <Box sx={{ display: 'grid', gridTemplateColumns: 'auto', columnGap: 1, rowGap: 1, px: 0 }}>
          <Typography sx={{ color: 'white', textAlign: 'center', marginTop: '0em' }} variant="h3" component="h3">White & Rosé</Typography>
            <MobileWineItem key={whiteRose1.id} menuItem={whiteRose1} ></MobileWineItem>
            <MobileWineItem key={whiteRose2.id} menuItem={whiteRose2} ></MobileWineItem>
            <MobileWineItem key={whiteRose3.id} menuItem={whiteRose3} ></MobileWineItem>
            <MobileWineItem key={whiteRose4.id} menuItem={whiteRose4} ></MobileWineItem>
            <MobileWineItem key={whiteRose5.id} menuItem={whiteRose5} ></MobileWineItem>
            <MobileWineItem key={whiteRose6.id} menuItem={whiteRose6} ></MobileWineItem>
          </Box>

          <Box sx={{ display: 'grid', gridTemplateColumns: 'auto', columnGap: 1, rowGap: 1, px: 0 }}>
          <Typography sx={{ color: 'white', textAlign: 'center', marginTop: '0.5em' }} variant="h3" component="h3">Red Wine</Typography>
            <MobileWineItem key={red1.id} menuItem={red1} ></MobileWineItem>
            <MobileWineItem key={red2.id} menuItem={red2} ></MobileWineItem>
            <MobileWineItem key={red3.id} menuItem={red3} ></MobileWineItem>
          </Box>

        </Container>
    </main>
  );
}

export default MobileWineMenu;
